/**
 * Base profile override component, used by the name and photo override
 * components.
 *
 * Provides a saveable text field for editing profile values with support for
 * canceling changes and reverting to the previous value.
 */
import { SaveableTextField } from 'component/form/saveable-text-field';
import { useState } from 'react';
import type { TLabel } from 'util/stdtypes';

export function ProfileOveride({
    onSave,
    onCancel,
    previousValue,
    label,
    testID,
    placeholder,
}: {
    onSave: (value: string) => void;
    onCancel: () => void;
    label: TLabel;
    testID: string;
    previousValue: string;
    placeholder: TLabel;
}) {
    const [value, setValue] = useState(previousValue);

    return (
        <SaveableTextField
            label={label}
            onCancel={() => {
                setValue(previousValue);
                onCancel();
            }}
            onChange={setValue}
            onSave={onSave}
            placeholder={placeholder}
            testID={testID}
            value={value}
        />
    );
}
